import { Component, Input, OnInit } from '@angular/core';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatalogModel, CatHybridCommissionSchema, ConfiguratedSchemaModel, CreatedSchemas, SaveFinalCommissionSubSchema, SelectedHSchema, TransitSchema } from 'src/app/model/other-catalogs-models';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CommissionSalePromotion } from 'src/app/model/commission-sale-promotion';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';
import { isNullOrUndefined } from 'util';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';
import { CatHybridCommissionSchemaService } from 'src/app/services/cat-hybrid-commission-schema.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-scheme-configurator',
  templateUrl: './modal-scheme-configurator.component.html',
  styleUrls: ['./modal-scheme-configurator.component.css']
})
export class ModalSchemeConfiguratorComponent implements OnInit {
  @Input() listConfiguratedSchema: ConfiguratedSchemaModel[];
  @Input() salePromotion:CommissionSalePromotion;
  @Input() salePromotionOld:CommissionSalePromotion;
  @Input() logDetails:string=null;
  @Input() page:string;
  @Input() mode:string;
  @Input() subSchemaHeader:CreatedSchemas;

//ACTIVAR O DESACTIVAR
public activeOrinactive:number= 0;
public statusResponse: string = "";

  // estado pagina
  public editDirectRate: boolean = true ;
  public valid:boolean=false;
  public error:boolean=false;
  public viewStatus:number=1;
  public enableMinCreditAdv:boolean=false;
  public filterProducts:boolean=true;
  public formIsLocked:boolean=false;
  public details:string=null;
  public validateDetails:string=null;
  public userChanges:string=null;
  public title:string=null;
  public validateTitle:string=null;
  public confirmTitle:string='<i class="icon-info-circled"></i>&nbsp;&nbsp;Ha ingresado la siguiente información. Está seguro de guardar?';
  public allAfiliates:boolean=false;
  public allPaymentTerms:boolean=false;
  public allCategories:boolean=false;
  public loadingProducts:number=0;
  public loadingAfiliates:number=0;
  public loadingPaymentTerms:number=0;
  public directRate:number;
  public subSchemaHeaderIdEdit: number;
  public ifExistOnTransit: number = 0;
  public modActiveId: number = 0 ;
  public excecuteSave:number=0;


  // catalogos
  public employeeJobCatalog:CatalogModel[]=[];
  public hybridSchemaCatalog:CatHybridCommissionSchema[]=[];
  public businessProductCatalog:HMGenericCatalog[]=[];
  public productCatalog:any[]=[]; //=ModalCommissionSalePromotionsComponent.tube;
  public afiliateCatalog:any[]=[];
  public paymentTermCatalog:any[]=[];
  public paymentTermCatalog2:any[]=[];
  public paymentTermCatalog3:any[]=[];
  public categoryCatalog:any[]=[];
  public categoryCatalogEdit:any[]=[];
  public selectedEmployeeJobsDD:string[]=[];
  public selectedHybridDD:any[]=[];
  public selectedBusinessProductsDD:string[]=[];
  public selectedEmployeeJobs:any[]=[];
  public selectedHybrid:any[]=[];
  public selectedBusinessProducts:any[]=[];
  public selectedProducts:any[] = [];
  public selectedAfiliates:any[]=[];
  public selectedPaymentTerms:any[]=[];
  public selectedPaymentTermsBoth:any[]=[];
  public selectedCategories:any[]=[];
  public newPaymentArray:any[]=[];
  public newPaymentRemoveArray:any[]=[];
  public applyCategory:boolean=false;
  public showPaymentCommission = true;
  public paymentCommission:any[]=[];
  public flatSchemaList: SelectedHSchema[]=[];
  public repeatedAffiliates: string []= [];
  public editing = 1;
  public transitSchemaOld:TransitSchema[]=[];



  //ARRAY COMBINACIONES
  public selectedCatAffiliate: number []=[];
  public selectedBusinessCoE :number[]=[];
  public selectedCatBusinessProduct: number[]=[];
  public selectedCatEmployeeJob: number []=[];
  public selectedTerm: number [] = [] ;
  public selectedhybridSchemaId: number;
  public selectedCatPromotor: number [] = [];
  public selectedTermsPromoter: number [] = [] ;
  public nonSelectedPaymentFull: number [] = [];

  public selectedCommisionPercent: number [] = [];
  public selectedCategory: any []=[];

  //INICIA LA INSTANCIA DEL OBJETO
  saveRequestDTO : SaveFinalCommissionSubSchema = {subSchemaHeader:{}, catOwnerType: {},
  catBusinessProduct: {},
  productosCOE:[],
  catAfiliateHM: {},
  catPaymentTerm: {},
  catEmployeeJob: {},
  catPromoterCategory: {},
  subSchemaHeaderId: {},
  termRate:{},

  hybridSchemaId: {}} as SaveFinalCommissionSubSchema;


  //EDIT VARIABLES
  public CatHybridCommissionSchema: number = 0;


  //VALIDADORES DE CAMPOS
  public affiliateVal : boolean = false;
  public termVal: boolean = false;
  public promoterVal: boolean = false;
  public directVal: boolean = false;



  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  /////////////////
  constructor(
    private otherCatalogService: OtherCatalogsService,
    private catEmployeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogService:HypermatrixCatalogsService,
    private commissionSalePromotionsService:CommissionSalePromotionsService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private categoryPromoterService:CatCategoryPromoterService,
    private catHybridComissionService:CatHybridCommissionSchemaService,
    private utils:UtilitiesService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    if(this.mode =="edit"){
      this.getTransitSchemaOld(this.subSchemaHeader.SubSchemaHeaderId)
    }

    this.getCatalogs(0);


    this.paymentTermCatalog2=[
      { _id : 1, _name : "12 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
      { _id : 2, _name : "18 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
      { _id : 4, _name : "24 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
      { _id : 7, _name : "36 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
      { _id : 10, _name : "48 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
      { _id : 12, _name : "60 MESES", _commission: null, _isEditable: true, _commissionApplied: false}
    ]



    if(this.mode==='create') {
      this.title = '<i class="icon-plus"></i>&nbsp;&nbsp;Crear Esquema';

    }

    if(this.mode==='detail' || this.mode==='delete' || this.mode==="toggleActive") {

      if(this.mode==='detail') this.confirmTitle = '<i class="icon-eye"></i>&nbsp;&nbsp;Detalle de la promoción de venta';
      if(this.mode==='delete') this.confirmTitle = '<i class="icon-attention"></i>&nbsp;&nbsp;Se eliminará el siguiente registro. Esta seguro de eliminar?';
      if(this.mode==='toggleActive') {
        this.toggleActive();
        this.confirmTitle = this.salePromotion.activeId ? '<i class="icon-attention"></i>&nbsp;&nbsp;Se activará el siguiente registro. Esta seguro de activar?' : '<i class="icon-attention"></i>&nbsp;&nbsp;Se desactivará el siguiente registro. Esta seguro de desactivar?';
      }

      let details = "";
      if(this.logDetails != null){
        details = this.logDetails
      } else {
        details = "<table cellpadding=\"4\"><tr class=\"border_bottom\"><td bgcolor=\"#ffffff\" valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Descripción:</font></b></td><td valign=\"top\">" + this.salePromotion.description + "</td></tr>";
        details = details + "<tr class=\"border_bottom\"><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Periodo:</font></b></td><td valign=\"top\">Del [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni) + "] al [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin) + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.salePromotion.commission + "%]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;% Adicional al esquema base:</font></b></td><td valign=\"top\">" + (this.salePromotion.additionalSchemaBase ? '[Sí]' : '[No]') + "</td></tr>";

        //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Medio Colocación:</font></b></td><td valign=\"top\">" + this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) + "</td></tr>";
        //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Originación Digital:</font></b></td><td valign=\"top\">" + (this.salePromotion.digitalOrigin ? '[Sí]' : '[No]') + "</td></tr>";
        //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Unifiel - Digifiel:</font></b></td><td valign=\"top\">" + (this.salePromotion.unifielDigifiel ? '[Sí]' : '[No]') + "</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto:</font></b></td><td valign=\"top\">De [" + this.salePromotion.saleAmountFrom + "] a [" + this.salePromotion.saleAmountTo + "]</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance mínimo del crédito:</font></b></td><td valign=\"top\">" + (this.salePromotion.minCreditAdv ? ('[Sí] del [' + this.salePromotion.minCreditAdvPerc + '%]') : '[No]') + "</td></tr>";

        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos:</font></b></td><td valign=\"top\">[" + this.salePromotion.employeeJobs + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio:</font></b></td><td valign=\"top\">[" + this.salePromotion.businessProducts + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos:</font></b></td><td valign=\"top\">[" + this.salePromotion.financingTypes + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios:</font></b></td><td valign=\"top\">[" + this.salePromotion.afiliates + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos:</font></b></td><td valign=\"top\">[" + this.salePromotion.paymentTerms + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones:</font></b></td><td valign=\"top\">[" + this.salePromotion.financing + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones:</font></b></td><td valign=\"top\">[" + this.salePromotion.regions + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados:</font></b></td><td valign=\"top\">[" + this.salePromotion.states + "]</td></tr>";
        details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Observaciones:</font></b></td><td valign=\"top\">" + this.salePromotion.observations + "</td></tr>";

        if(this.mode==='detail' || this.mode==='delete') details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Activo:</font></b></td><td valign=\"top\">" + (this.salePromotion.activeId ? '[Sí]' : '[No]') + "</td></tr>";

        details = details + "</table>";
      }

      this.details = details;
      this.viewStatus = 2;
    }

    let modalContent:any = $('.modal-content');
        modalContent.draggable({
          handle: '.card-header'
          // , drag: function() {
          //   document.querySelector<HTMLElement>(".card-modal").classList.add("backdrop-modal");
          // }
        });

        if(this.mode === 'edit' /*&& this.salePromotion.salePromotionId != null && this.salePromotion.salePromotionId > 0*/) {
          this.title = '<i class="icon-pencil"></i>&nbsp;&nbsp;Editar Esquema ' ;


        }
  }

  toNgDate(strDate) {
    if (strDate) {
      const [year, month, day] = strDate.split('-');
      const obj = { year: parseInt(year), month: parseInt(month), day:
        parseInt(day.split(' ')[0].trim()) };

      return new NgbDate(obj.year, obj.month, obj.day);
    }
  }

  //
  isValid=()=> {
    this.valid=true;
    let errors=[];

    if(this.descriptionError()) errors.push('&bull; Ingrese una descripción!');
    if(this.promotionDateIniError()) errors.push('&bull; Ingrese una fecha de inicio del periodo!');
    if(this.promotionDateFinError()) errors.push('&bull; Ingrese una fecha de fin del periodo!');
    if(this.employeeJobError()) errors.push('&bull; Seleccione un puesto!');
    if(this.businessProductError()) errors.push('&bull; Seleccione una o varias linea de negocio!');
    if(this.selectedProductsError()) errors.push('&bull; Seleccione uno o varios productos!');
    if(this.selectedAfiliatesError()) errors.push('&bull; Seleccione uno o varios convenios!');
    if(this.selectedPaymentTermsError()) errors.push('&bull; Seleccione uno o varios plazos!');
    if(this.commissionError()) errors.push('&bull; Ingrese una comisión!');
    if(this.saleAmountFromError()) errors.push('&bull; Ingrese un monto inicial de venta!');
    if(this.saleAmountToError()) errors.push('&bull; Ingrese un monto final de venta!');
    if(this.saleAmountFromToError()) errors.push('&bull; El monto inicial no puede ser mayor al monto final!');
    if(this.minCreditAdvPercError()) errors.push('&bull; Ingrese un porcentaje de avance mínimo de crédito!');
    if(this.observationsError()) errors.push('&bull; Las observaciones NO pueden contener más de 550 carácteres!');

    if(errors.length>0) {
      this.valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }

    if(this.valid){

      let details = "<table cellpadding=\"4\" border=\"0\">";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Descripción:</font></b></td><td valign=\"top\">" + this.salePromotion.description + "</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Periodo:</font></b></td><td valign=\"top\">Del [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni) + "] al [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin) + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.salePromotion.commission + "%]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;% Adicional al esquema base:</font></b></td><td valign=\"top\">" + (this.salePromotion.additionalSchemaBase ? '[Sí]' : '[No]') + "</td></tr>";

      //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Medio Colocación:</font></b></td><td valign=\"top\">" + this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) + "</td></tr>";
      //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Originación Digital:</font></b></td><td valign=\"top\">" + (this.salePromotion.digitalOrigin ? '[Sí]' : '[No]') + "</td></tr>";
      //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Unifiel - Digifiel:</font></b></td><td valign=\"top\">" + (this.salePromotion.unifielDigifiel ? '[Sí]' : '[No]') + "</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto:</font></b></td><td valign=\"top\">De [" + (!isNullOrUndefined(this.salePromotion.saleAmountFrom) ? this.salePromotion.saleAmountFrom : "0") + "] a [" + (!isNullOrUndefined(this.salePromotion.saleAmountTo) ? this.salePromotion.saleAmountTo : "0") + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance mínimo del crédito:</font></b></td><td valign=\"top\">" + (this.salePromotion.minCreditAdv ? ('[Sí] del [' + this.salePromotion.minCreditAdvPerc + '%]') : '[No]') + "</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos:</font></b></td><td valign=\"top\">[";
      this.selectedEmployeeJobs.forEach((el)=>{
        details = details + el.description + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio:</font></b></td><td valign=\"top\">[";
      this.selectedBusinessProducts.forEach((el)=>{
        details = details + el.description + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos:</font></b></td><td valign=\"top\">[";
      this.selectedProducts.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios:</font></b></td><td valign=\"top\">[";
      this.selectedAfiliates.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos:</font></b></td><td valign=\"top\">[";
      this.selectedPaymentTerms.forEach((el)=>{
        details = details + el._name + ", ";
      });
      details = details.substring(0,details.length-2) + "]</td></tr>";

      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Observaciones:</font></b></td><td valign=\"top\">" + this.salePromotion.observations + "</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Activo:</font></b></td><td valign=\"top\">" + (this.salePromotion.activeId ? '[Sí]' : '[No]') + "</td></tr>";
      details = details + "</table>";

      this.details = details;

      if(this.mode === "edit"){

        let userChanges = "<table cellpadding=\"4\" border=\"0\">";

        let selectedBusinessProductsOld:string[]=[];
        let selectedEmployeeJobsOld:string[]=[];
        let selectedProductsOld:string[]=[];
        let selectedAfiliatesOld:string[]=[];
        let selectedPaymentTermsOld:string[]=[];
        let selectedPromosOld:string[]=[];
        let selectedRegionsOld:string[]=[];
        let selectedStatesOld:string[]=[];
        let selectedBusinessProductsNew:string[]=[];
        let selectedEmployeeJobsNew:string[]=[];
        let selectedProductsNew:string[]=[];
        let selectedAfiliatesNew:string[]=[];
        let selectedPaymentTermsNew:string[]=[];
        let selectedPromosNew:string[]=[];
        let selectedRegionsNew:string[]=[];
        let selectedStatesNew:string[]=[];

        //ORIGINAL
        if(this.salePromotionOld.businessProducts != null && this.salePromotionOld.businessProducts.length > 0) {
          this.salePromotionOld.businessProducts.split(",").forEach(s => selectedBusinessProductsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.employeeJobs != null && this.salePromotionOld.employeeJobs.length > 0) {
          this.salePromotionOld.employeeJobs.split(",").forEach(s => selectedEmployeeJobsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.financingTypes != null && this.salePromotionOld.financingTypes.length > 0) {
          this.salePromotionOld.financingTypes.split(",").forEach(s => selectedProductsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.afiliates != null && this.salePromotionOld.afiliates.length > 0) {
          this.salePromotionOld.afiliates.split(",").forEach(s => selectedAfiliatesOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.paymentTerms != null && this.salePromotionOld.paymentTerms.length > 0) {
          this.salePromotionOld.paymentTerms.split(",").forEach(s => selectedPaymentTermsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.financing != null && this.salePromotionOld.financing.length > 0) {
          this.salePromotionOld.financing.split(",").forEach(s => selectedPromosOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.regions != null && this.salePromotionOld.regions.length > 0) {
          this.salePromotionOld.regions.split(",").forEach(s => selectedRegionsOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        if(this.salePromotionOld.states != null && this.salePromotionOld.states.length > 0) {
          this.salePromotionOld.states.split(",").map(s => selectedStatesOld.push(this.utils.removeDiacriticsAndSpaces(s, true)));
        }

        //NUEVO
        this.selectedBusinessProducts.forEach((el)=> selectedBusinessProductsNew.push(this.utils.removeDiacriticsAndSpaces(el.description, true)));
        this.selectedEmployeeJobs.forEach((el)=>selectedEmployeeJobsNew.push(this.utils.removeDiacriticsAndSpaces(el.description, true)));
        this.selectedProducts.forEach((el)=>selectedProductsNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedAfiliates.forEach((el)=>selectedAfiliatesNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));
        this.selectedPaymentTerms.forEach((el)=>selectedPaymentTermsNew.push(this.utils.removeDiacriticsAndSpaces(el._name, true)));

        selectedBusinessProductsNew = selectedBusinessProductsNew.filter(r=>!selectedBusinessProductsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedEmployeeJobsNew = selectedEmployeeJobsNew.filter(r=>!selectedEmployeeJobsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedProductsNew = selectedProductsNew.filter(r=>!selectedProductsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedAfiliatesNew = selectedAfiliatesNew.filter(r=>!selectedAfiliatesOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPaymentTermsNew = selectedPaymentTermsNew.filter(r=>!selectedPaymentTermsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPromosNew = selectedPromosNew.filter(r=>!selectedPromosOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedRegionsNew = selectedRegionsNew.filter(r=>!selectedRegionsOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedStatesNew = selectedStatesNew.filter(r=>!selectedStatesOld.includes(this.utils.removeDiacriticsAndSpaces(r, true)));

        let selectedBusinessProductsDescr:string[] = this.selectedBusinessProducts.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row.description, true);
        },this);

        let selectedEmployeeJobsDescr:string[] = this.selectedEmployeeJobs.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row.description, true);
        },this);

        let selectedProductsDescr:string[] = this.selectedProducts.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedAfiliatesDescr:string[] = this.selectedAfiliates.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        let selectedPaymentTermsDescr:string[] = this.selectedPaymentTerms.map(function(row) {
          return this.utils.removeDiacriticsAndSpaces(row._name, true);
        },this);

        selectedBusinessProductsOld = selectedBusinessProductsOld.filter(r=>!selectedBusinessProductsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedEmployeeJobsOld = selectedEmployeeJobsOld.filter(r=>!selectedEmployeeJobsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedProductsOld = selectedProductsOld.filter(r=>!selectedProductsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedAfiliatesOld = selectedAfiliatesOld.filter(r=>!selectedAfiliatesDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));
        selectedPaymentTermsOld = selectedPaymentTermsOld.filter(r=>!selectedPaymentTermsDescr.includes(this.utils.removeDiacriticsAndSpaces(r, true)));

        if(!(this.utils.removeDiacriticsAndSpaces(this.salePromotion.description, true) === this.utils.removeDiacriticsAndSpaces(this.salePromotionOld.description, true)))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Descripción:</font></b></td><td valign=\"top\">" + this.salePromotion.description + "</td></tr>";

        if(!(this.salePromotion.promotionDateIni === this.salePromotionOld.promotionDateIni) || !(this.salePromotion.promotionDateFin === this.salePromotionOld.promotionDateFin))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Periodo:</font></b></td><td valign=\"top\">Del [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateIni) + "] al [" + this.utils.convertToDDMMYYYY(this.salePromotion.promotionDateFin) + "]</td></tr>";

        if(!(this.salePromotion.commission === this.salePromotionOld.commission))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión:</font></b></td><td valign=\"top\">[" + this.salePromotion.commission + "%]</td></tr>";

        if(!(this.salePromotion.additionalSchemaBase === this.salePromotionOld.additionalSchemaBase))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;% Adicional al esquema base:</font></b></td><td valign=\"top\">" + (this.salePromotion.additionalSchemaBase ? '[Sí]' : '[No]') + "</td></tr>";

        // if(!(this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) === this.getOrigin(this.salePromotionOld.digitalOrigin, this.salePromotionOld.unifielDigifiel, this.salePromotionOld.traditionalOrigin)))
        //   userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Medio Colocación:</font></b></td><td valign=\"top\">" + this.getOrigin(this.salePromotion.digitalOrigin, this.salePromotion.unifielDigifiel, this.salePromotion.traditionalOrigin) + "</td></tr>";
        //if(!(this.salePromotion.digitalOrigin === this.salePromotionOld.digitalOrigin))
        //   userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Originación Digital:</font></b></td><td valign=\"top\">" + (this.salePromotion.digitalOrigin ? '[Sí]' : '[No]') + "</td></tr>";
        //if(!(this.salePromotion.unifielDigifiel === this.salePromotionOld.unifielDigifiel))
        //   userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Unifiel - Digifiel:</font></b></td><td valign=\"top\">" + (this.salePromotion.unifielDigifiel ? '[Sí]' : '[No]') + "</td></tr>";

        if(isNullOrUndefined(this.salePromotionOld.saleAmountFrom)) this.salePromotionOld.saleAmountFrom = 0;
        if(isNullOrUndefined(this.salePromotionOld.saleAmountTo)) this.salePromotionOld.saleAmountTo = 0;
        if(isNullOrUndefined(this.salePromotion.saleAmountFrom)) this.salePromotion.saleAmountFrom = 0;
        if(isNullOrUndefined(this.salePromotion.saleAmountTo)) this.salePromotion.saleAmountTo = 0;
        if(!(this.salePromotion.saleAmountFrom === this.salePromotionOld.saleAmountFrom) || !(this.salePromotion.saleAmountTo === this.salePromotionOld.saleAmountTo))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Monto:</font></b></td><td valign=\"top\">De [" + this.salePromotion.saleAmountFrom + "] a [" + this.salePromotion.saleAmountTo + "]</td></tr>";

        if(isNullOrUndefined(this.salePromotion.minCreditAdvPerc)) this.salePromotion.minCreditAdvPerc = 0;
        if(!(this.salePromotion.minCreditAdvPerc === this.salePromotionOld.minCreditAdvPerc))
           userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance mínimo del crédito:</font></b></td><td valign=\"top\">" + (this.salePromotion.minCreditAdv ? "[Sí] del [" + this.salePromotion.minCreditAdvPerc + "%]" : "[No]") + "</td></tr>";

        if(selectedEmployeeJobsNew.length > 0){
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos Agregados:</font></b></td><td valign=\"top\">[";
          selectedEmployeeJobsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedEmployeeJobsOld.length > 0){
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Puestos Descartados:</font></b></td><td valign=\"top\">[";
          selectedEmployeeJobsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedBusinessProductsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio Agregadas:</font></b></td><td valign=\"top\">[";
          selectedBusinessProductsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedBusinessProductsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Lineas de Negocio Descartadas:</font></b></td><td valign=\"top\">[";
          selectedBusinessProductsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0, userChanges.length-2) + "]</td></tr>";
        }

        if(selectedProductsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos Agregados:</font></b></td><td valign=\"top\">[";
          selectedProductsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedProductsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Productos Descartados:</font></b></td><td valign=\"top\">[";
          selectedProductsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedAfiliatesNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios Agregados:</font></b></td><td valign=\"top\">[";
          selectedAfiliatesNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedAfiliatesOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenios Descartados:</font></b></td><td valign=\"top\">[";
          selectedAfiliatesOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPaymentTermsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos Agregados:</font></b></td><td valign=\"top\">[";
          selectedPaymentTermsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPaymentTermsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazos Descartados:</font></b></td><td valign=\"top\">[";
          selectedPaymentTermsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPromosNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones Agregadas:</font></b></td><td valign=\"top\">[";
          selectedPromosNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedPromosOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Promociones Descartadas:</font></b></td><td valign=\"top\">[";
          selectedPromosOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedRegionsNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones Agregadas:</font></b></td><td valign=\"top\">[";
          selectedRegionsNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedRegionsOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Regiones Descartadas:</font></b></td><td valign=\"top\">[";
          selectedRegionsOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedStatesNew.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados Agregados:</font></b></td><td valign=\"top\">[";
          selectedStatesNew.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(selectedStatesOld.length > 0) {
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Estados Descartados:</font></b></td><td valign=\"top\">[";
          selectedStatesOld.forEach((el)=>userChanges = userChanges + el + ", ");
          userChanges = userChanges.substring(0,userChanges.length-2) + "]</td></tr>";
        }

        if(!(this.utils.removeDiacriticsAndSpaces(this.salePromotion.observations, true) === this.utils.removeDiacriticsAndSpaces(this.salePromotionOld.observations, true)))
          userChanges = userChanges + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Observaciones:</font></b></td><td valign=\"top\">" + this.salePromotion.observations + "</td></tr>";

        this.userChanges = userChanges + "</table>";
        //console.log(">> this.userChanges=", this.userChanges);
      }

      this.viewStatus = 2;
    }else{
      this.viewStatus = 1;
      this.details = null;
      this.userChanges = null;
    }
  }

  closeConfirm=()=> {
    if(this.mode==="delete" || this.mode==="toggleActive" || this.mode==="detail"){
      this.modalService.dismissAll();
    }else{
      this.viewStatus = 1;
      this.details = null;
      this.validateDetails = null;
      this.userChanges = null;
    }
  }

  save=()=> {
    if(this.error){
      this.modalService.dismissAll('success');
      return;
    }

    if(this.mode==="delete" || this.mode==="toggleActive"){

      delete this.salePromotion.employeeJobs;
      delete this.salePromotion.businessProducts;
      delete this.salePromotion.financingTypes;
      delete this.salePromotion.afiliates;
      delete this.salePromotion.paymentTerms;
      delete this.salePromotion.financing;
      delete this.salePromotion.createDate;
      delete this.salePromotion.modifDate;
      delete this.salePromotion.regions;
      delete this.salePromotion.states;

      this.salePromotion.modifUserId=Number(localStorage.getItem('com_token'));

      let request:any = {
        commissionSalePromotion: this.salePromotion,
        "listEmployeeJobs": [],
        "listBusinessProducts": [],
        "listFinancingTypes": [],
        "listPaymentTerms": [],
        "listAfiliates": [],
        "listFinancing": [],
        "listRegions": [],
        "listStates": [],
        "details": this.details
      };


      if(this.mode==="delete"){
        request.userChanges = "Se ha eliminado la comisión de venta!";
        this.commissionSalePromotionsService.delete(request)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.modalService.dismissAll('success');
            this.toastr.success('El registro se ha eliminado correctamente!');
          }
          if(resp && resp.codeHttpStatus===409) {
            this.confirmTitle='<i class="icon-attention"></i>&nbsp;&nbsp; Error al eliminar!';
            this.details = '<h6>No se pude eliminar el registro seleccionado debido a reglas de negocio!</h6>';
            this.error = true;
          }
        });
      }

      if(this.mode==="toggleActive"){
        let status = this.salePromotion.activeId ? 'activado' : 'desactivado';
        request.userChanges = "Se ha " + status + " la comisión de venta!";
        this.commissionSalePromotionsService.updateStatus(request)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.modalService.dismissAll('success');
            this.toastr.success('El registro se ha ' + status + ' correctamente!');
          }
        });
      }
    }

    if(this.mode==="create" || this.mode==="edit"){
      if(this.valid && this.details != null) {
        this.viewStatus=0;
        let request:any = {
          commissionSalePromotion: {
            "description": this.salePromotion.description,
            "promotionDateIni": this.salePromotion.promotionDateIni,
            "promotionDateFin": this.salePromotion.promotionDateFin,
            "saleAmountFrom": !isNullOrUndefined(this.salePromotion.saleAmountFrom) ? this.salePromotion.saleAmountFrom : 0,
            "saleAmountTo": !isNullOrUndefined(this.salePromotion.saleAmountTo) ? this.salePromotion.saleAmountTo : 0,
            "commission": this.salePromotion.commission,
            "additionalSchemaBase": this.salePromotion.additionalSchemaBase,
            "digitalOrigin": this.salePromotion.digitalOrigin,
            "unifielDigifiel": this.salePromotion.unifielDigifiel,
            "traditionalOrigin": this.salePromotion.traditionalOrigin,
            "minCreditAdv": this.salePromotion.minCreditAdv,
            "minCreditAdvPerc": !isNullOrUndefined(this.salePromotion.minCreditAdvPerc) ? this.salePromotion.minCreditAdvPerc : 0,
            "observations": this.salePromotion.observations,
            "onlyRefi": this.enableMinCreditAdv
          },
          "listEmployeeJobs": this.selectedEmployeeJobs.map(function(row) {
            return row.id;
          }),
          "listBusinessProducts": this.selectedBusinessProducts.map(function(row) {
            return row.id;
          }),
          "listFinancingTypes": this.selectedProducts.map(function(row) {
            return row._id;
          }),
          "listPaymentTerms": this.selectedPaymentTerms.map(function(row) {
            return row._id;
          }),
          "listAfiliates": this.selectedAfiliates.map(function(row) {
            return row._id;
          }),
          "details": this.details
        };

        if(this.mode === 'edit' && this.salePromotion.salePromotionId != null && this.salePromotion.salePromotionId > 0){
          request.commissionSalePromotion.salePromotionId = this.salePromotion.salePromotionId;
          request.commissionSalePromotion.activeId = this.salePromotion.activeId;
          request.commissionSalePromotion.createUserId = this.salePromotion.createUserId;
          request.commissionSalePromotion.modifUserId = Number(localStorage.getItem('com_token'));
          request.userChanges = this.userChanges;
        }else{
          request.commissionSalePromotion.createUserId = this.salePromotion.createUserId;
          request.userChanges = this.details;
        }

        this.validateRequest(request);
      }
    }
  }

  validateRequest=(request:any)=>{
    console.log(">>> validateRequest >> request=", request);
    this.commissionSalePromotionsService.validate(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> validateRequest >> response=", resp);
          if(resp.data2 != null){
            if(Number(resp.data2) > 0){
              this.viewStatus = 3;
              if(resp.data2 === 1){
                this.validateTitle = "&nbsp;&nbsp;No se pueden editar la promoción de venta!";
                this.validateDetails = "La promoción de venta ya ha sido aplicada en comisiones diarias!<br/><br/>";
              }
              if(resp.data2 === 2){
                this.validateTitle = "&nbsp;&nbsp;Existen promociones de venta con la misma descripción!";
                this.validateDetails = "Las siguiente promoción de venta tienen la misma descripción:<br/><br/>";
                resp.data.forEach((s)=>{
                  this.validateDetails = this.validateDetails + "&bull;&nbsp;&nbsp;" + s + "<br/>";
                },this);
              }
              if(resp.data2 === 3){
                this.validateTitle = "&nbsp;&nbsp;Existen promociones de venta activas y vigentes que contemplan esta información!";
                this.validateDetails = "Favor de verificar las siguientes promociones de venta:<br/><br/>";
                resp.data.forEach((s)=>{
                  this.validateDetails = this.validateDetails + "&bull;&nbsp;&nbsp;" + s + "<br/>";
                },this);
              }
            }else{
              //console.log(">> SAVE");

              this.saveRequest(request);
            }
          }else{
            this.toastr.error('Ocurrió un error al procesar la solicitud...');
            this.viewStatus=1;
          }
        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al procesar la solicitud...'));
        })
      )
      .subscribe();
  }

  saveRequest=(request:any)=>{
    this.commissionSalePromotionsService.save(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            request.commissionSalePromotion.salePromotionId = resp.data.salePromotionId;
            //this.saveConfigsAsync(request);
            this.modalService.dismissAll('success');
            this.toastr.success('La promoción de venta se guardó con éxito!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
        })
      )
      .subscribe();
  }

  saveConfigsAsync=(request:any)=>{
    console.log(">>> saveConfigsAsync >> request=", request);
    this.commissionSalePromotionsService.saveConfigsAsync(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveConfigsAsync >> response=", resp);
          if(resp.data != null && (resp.codeHttpStatus === 200)){
            this.modalService.dismissAll('success');
            this.toastr.success('La promoción de venta se guardó con éxito!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
          }
        }),
        catchError(error=> {
          console.log("-- error ini --------------------------------------------------------------------------------")
          console.log(error);
          console.log("-- error fin --------------------------------------------------------------------------------")
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta...'));
        })
      )
      .subscribe();
  }


  close=()=> {
    this.modalService.dismissAll('cancel');
  }

  // HELPERS
  descriptionError=()=> (this.salePromotion.description!=="" && !this.salePromotion.description) || this.salePromotion.description==="";
  promotionDateIniError=()=> this.salePromotion.promotionDateIni!=="" && !this.salePromotion.promotionDateIni;
  promotionDateFinError=()=> this.salePromotion.promotionDateFin!=="" && !this.salePromotion.promotionDateFin;
  employeeJobError=()=> !(this.selectedEmployeeJobs != null && this.selectedEmployeeJobs.length > 0);
  businessProductError=()=> !(this.selectedBusinessProducts != null && this.selectedBusinessProducts.length > 0);
  selectedProductsError=()=> !(this.selectedProducts != null && this.selectedProducts.length > 0);
  selectedAfiliatesError=()=> !(this.selectedAfiliates != null && this.selectedAfiliates.length > 0);
  selectedPaymentTermsError=()=> !(this.selectedPaymentTerms != null && this.selectedPaymentTerms.length > 0);
  commissionError=()=> this.salePromotion.commission!==0 && !this.salePromotion.commission;
  saleAmountFromError=()=> isNullOrUndefined(this.salePromotion.saleAmountFrom) && this.salePromotion.saleAmountTo != null;
  saleAmountToError=()=> isNullOrUndefined(this.salePromotion.saleAmountTo) && this.salePromotion.saleAmountFrom != null;
  saleAmountFromToError=()=> (this.salePromotion.saleAmountFrom != null && this.salePromotion.saleAmountTo != null) && (this.salePromotion.saleAmountFrom >= this.salePromotion.saleAmountTo);
  minCreditAdvPercError=()=> isNullOrUndefined(this.salePromotion.minCreditAdvPerc) && this.salePromotion.minCreditAdv;
  compare(a:any, b:any) {
		const arr = [];
		return arr.indexOf(a._id) - arr.indexOf(b._id);
	}
  updateCommission=e=> this.salePromotion.commission=!e || e.trim()===''?null:Number(e);
  updateSaleAmountFrom=e=> this.salePromotion.saleAmountFrom=!e || e.trim()===''?null:Number(e);
  updateSaleAmountTo=e=> this.salePromotion.saleAmountTo=!e || e.trim()===''?null:Number(e);
  updateMinCreditAdvPerc=e=> this.salePromotion.minCreditAdvPerc=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.salePromotion.activeId=!this.salePromotion.activeId;
  toggleAdditionalSchema=()=> this.salePromotion.additionalSchemaBase = !this.salePromotion.additionalSchemaBase;
  toggleDigitalOrigin=()=> this.salePromotion.digitalOrigin = !this.salePromotion.digitalOrigin;
  toggleUnifielDigifiel=()=> this.salePromotion.unifielDigifiel = !this.salePromotion.unifielDigifiel;
  toggleMinCreditAdv=()=> this.salePromotion.minCreditAdv = !this.salePromotion.minCreditAdv;
  observationsError=()=> this.salePromotion.observations!==null && this.salePromotion.observations.length > 550;

  // EVENTS
  employeeJobChange=e=> {
    if (this.mode === 'create'){
      if(e.length > 0){
        this.selectedEmployeeJobs=e;
        console.log(">> this.selectedEmployeeJobs= ", this.selectedEmployeeJobs);
      } else {
        this.selectedEmployeeJobs=[];
      }
      console.log(">>  this.selectedEmployeeJobsDD= ",  this.selectedEmployeeJobsDD);

    }else if (this.mode === 'edit'){

      if(this.mode === 'edit'){
        if(e.length > 0){
          this.selectedEmployeeJobsDD=[];
          this.selectedEmployeeJobs = []
          this.selectedEmployeeJobs=e;
        }else {
          this.selectedEmployeeJobs=[];
        }
        e.forEach(el => {
          this.selectedEmployeeJobs.push({id: el})
        });

        this.selectedEmployeeJobs.forEach((el)=>{
          if(el.id!== undefined){
            this.selectedEmployeeJobsDD.push(el.id);
          }

        })

        console.log(">> this.selectedEmployeeJobs= ", this.selectedEmployeeJobs);
      } else {
        this.selectedEmployeeJobs=[];
      }
      console.log(">>  this.selectedEmployeeJobsDD= ",  this.selectedEmployeeJobsDD);
    }

  };
  hybridChange=e=> { //OBTIENE LOS CAMPOS QUE SE DEBERÁN MOSTRAR DE FORMA DINÁMICA.

    console.log(">> this.HybridCommissionSchema= ", e);
    if (this.mode === 'create'){
      this.selectedhybridSchemaId = e[0].hybridSchemaId;

      this.getSelectedHSchema(this.selectedhybridSchemaId.toString());
    }else if (this.mode === 'edit' && this.selectedhybridSchemaId == null){
      this.selectedhybridSchemaId = e.Value;
      //////console.warn("ID SELECCIONADO",this.selectedhybridSchemaId)
      this.selectedHybrid.push(this.selectedhybridSchemaId);
      this.getSelectedHSchema(this.selectedhybridSchemaId.toString());
    }else {
      this.selectedhybridSchemaId = e[0].hybridSchemaId;
      //console.log("ID SELECCIONADO",this.selectedhybridSchemaId)
      this.getSelectedHSchema(this.selectedhybridSchemaId.toString());
    }


  };



  businessProductChange=e=>{

    //this.selectedPaymentTerms=[];
    this.selectedCategories=[];
    this.productCatalog=[];
    this.afiliateCatalog=[];
    //this.paymentTermCatalog=[];
    //////console.error(e);
    if(e.length > 0 || this.mode === 'edit' ){
      if (this.mode === 'create' ){
        this.selectedProducts=[];
        this.selectedAfiliates=[];
        this.selectedBusinessProducts=e;
      }else if(this.mode === 'edit' ){
        e.forEach(el => {
          this.selectedBusinessProducts.push({id: el})
        });
        //this.selectedBusinessProducts = [{id: e[0]},{id: e[1]} ]
        this.selectedBusinessProducts.forEach((el)=>{
          if(this.selectedBusinessProducts !== undefined){
            this.selectedBusinessProductsDD.push(el.id)
          }

        })

        console.log("ID SELECCIONADO DD",this.selectedBusinessProducts)
        console.log("ID SELECCIONADO DD",this.selectedBusinessProductsDD)

      }else{
        this.selectedBusinessProducts=e;
      }


      //Cargar PRODUCTOS X LINEA DE NEGOCIO seleccionada
      if(this.selectedBusinessProducts != null && this.selectedBusinessProducts.length>0){
        this.loadingProducts = 1;
        let businessProductId:number[]=[];
        this.selectedBusinessProducts.forEach((el)=>{

          businessProductId.push(el.id);
        });

        this.vwCommissionConfiguratorService.getFinancingTypesByBusinessProduct(businessProductId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.productCatalog = resp.data.map(function(row) {
              return { _id : row.id, _name : row.description }
            });
            this.loadingProducts = 0;
          }
        });
      }


    }else{
      this.selectedBusinessProducts=[];
    }
  };

  productsChange=e=> {
    console.log(">> this.selectedProducts= ", this.selectedProducts);
    if (this.mode === 'create'){
      this.selectedAfiliates=[];
      this.afiliateCatalog=[];
    }

    //this.selectedPaymentTerms=[];

    //this.paymentTermCatalog=[];

    //Cargar CONVENIOS X PRODUCTO seleccionado
    this.loadConveniosXProducto();
  }

  loadConveniosXProducto(){
    //Cargar CONVENIOS X PRODUCTO seleccionado
    console.log(">> this.selectedProducts= 2 ", this.selectedProducts);
    if(this.selectedProducts != null && this.selectedProducts.length > 0){
      this.loadingAfiliates = 1;
      let financingTypeId:number[]=[];
      this.selectedProducts.forEach((el)=>{
        financingTypeId.push(el._id);
      });
      this.vwCommissionConfiguratorService.getAfiliatesByFinancingType(financingTypeId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          console.log(">> this.selectedProducts= ", resp);
          this.afiliateCatalog=resp.data.map(function(row) {

            return { _id : row.id, _name : row.description }
          });
          console.log( this.afiliateCatalog);// catalogo de convenios
          this.loadingAfiliates = 0;
        }
      });
    }
  }

  loadtodosConveniosXProducto(){
    //Cargar CONVENIOS X PRODUCTO seleccionado
    console.log(">> this.selectedProducts= 3 ", this.productCatalog);
    if(this.productCatalog != null && this.productCatalog.length > 0){
      this.loadingAfiliates = 1;
      let financingTypeId:number[]=[];
      this.productCatalog.forEach((el)=>{
        financingTypeId.push(el._id);
      });
      this.vwCommissionConfiguratorService.getAfiliatesByFinancingType(financingTypeId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          console.log(">> this.selectedProducts= ", resp);
          this.afiliateCatalog=resp.data.map(function(row) {

            return { _id : row.id, _name : row.description, }
          });

          console.log(this.afiliateCatalog);// catalogo de convenios
          this.loadingAfiliates = 0;
          this.ReadSelectedValues();
        }
      });
    }
  }

  afiliatesChange=e=> {
      //this.selectedPaymentTerms=[];
      //this.paymentTermCatalog=[];
      //////console.error("convenios seleccionados ", this.selectedAfiliates)
      //Cargar PLAZOS X CONVENIO seleccionado
      if(this.selectedAfiliates != null && this.selectedAfiliates.length > 0 ){
        this.loadingPaymentTerms = 1;

        let afiliateId:number[]=[];
        this.allAfiliates = false;

        this.selectedAfiliates.forEach((el)=>{
          if(el._id === 0) this.allAfiliates = true

        },this);

        //Agregar TODOS los CONVENIOS
        if(this.allAfiliates){

          this.selectedAfiliates = []; //this.selectedAfiliates.filter(item => item._id === 0);
          this.selectedAfiliates.push({ _id:0, _name:"«TODOS»" });
          this.afiliateCatalog.forEach((el)=>{
            if(el._id > 0) {

              this.selectedAfiliates.push(el);
            }
          },this);
        }

        this.selectedAfiliates.forEach((el)=>{

          if(el._id > 0) afiliateId.push(el._id.toString());
          ////console.error(afiliateId)
        });

        /*this.vwCommissionConfiguratorService.getPaymentTermsByAfiliate(afiliateId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.paymentTermCatalog=resp.data.map(function(row) {
              if(row.id!==21 && row.id!==22 && row.id!==23) return { _id : row.id, _name : row.description }
            });
            this.loadingPaymentTerms = 0;
          }
        });*/
      }
  }

  paymentTermsChange=e=> {
    this.allPaymentTerms = false;
    this.selectedPaymentTerms.forEach((el)=>{
      if(el._id === 0) this.allPaymentTerms = true;
    },this);

    //Agregar TODOS los PLAZOS
    if(this.allPaymentTerms){
      this.selectedPaymentTerms = [];
      //this.selectedPaymentTerms.push({ _id:0, _name:"« TODOS »" });
      this.paymentTermCatalog2.forEach((el)=>{
        if(el._id > 0) {
          this.selectedPaymentTerms.push(el);
        }
      },this);
    }

    //Llena la tabla de plazos con tasa configurada
    if(!this.applyCategory){
      this.showPaymentCommission=false;
      //console.log(">> LOCAL NEW ARRAY:" + JSON.stringify(localStorage.getItem("PaymentArray")));
      //console.log(">> LOCAL REMOVE ARRAY:" + JSON.stringify(localStorage.getItem("PaymentArrayRemove")));
      let pa = localStorage.getItem("PaymentArray");
      let par = localStorage.getItem("PaymentArrayRemove");
      //console.log(">> LENTGH PA: "+pa.length);
      //console.log(">> LENTGH PAR: "+par.length);

      if(pa.length > 0){
        this.newPaymentArray = JSON.parse(localStorage.getItem("PaymentArray"));
        console.log(">> EXISTE newPaymentArray: "+ this.newPaymentArray);
        let newPaymentArray = JSON.parse(localStorage.getItem("PaymentArray"));
        newPaymentArray.forEach((el)=>{
          this.paymentCommission.push({_plazo:el._name, _comision:localStorage.getItem("PaymentCommission")});
        });
      }

      if(par.length > 0){
        this.newPaymentRemoveArray = JSON.parse(localStorage.getItem("PaymentArrayRemove"));
        console.log(">> EXISTE newPaymentRemoveArray: "+ this.newPaymentRemoveArray);
        let newPaymentRemoveArray = JSON.parse(localStorage.getItem("PaymentArrayRemove"));
        newPaymentRemoveArray.forEach((el)=>{
          //this.paymentCommission.splice();
        });
      }

      //console.log(">> COMISIONES POR PLAZO: "+JSON.stringify(this.paymentCommission));
      localStorage.setItem("PaymentArray","");
      localStorage.setItem("PaymentCommission","");
      localStorage.setItem("PaymentArrayRemove","");
    }
  }

  categoriesPromotorChange=e=> {
    this.allCategories = false;
    this.selectedCategories.forEach((el)=>{
      if(el._id === 0) this.allCategories = true;
    },this);

    if(this.allCategories){
      //this.selectedCategories.push({ _id:0, _name:"«TODOS»" });
      this.categoryCatalog.forEach((el)=>{
        if(el._id > 0) {
          this.selectedCategories.push(el);
        }
      },this);
    }
  }

  getCatalogs=(commissionSaleId:number)=> {
    this.viewStatus=0;
    forkJoin(

      this.catEmployeeJobService.catalog(), //Puestos
      this.hypermatrixCatalogService.getCatalog('BusinessProductType'),//Lineas de negocio
      this.catHybridComissionService.getAll(), //ESQUEMAS HIBRIDOS

    )
    .pipe(
      tap(([catEmpJobResp,bpResp,hybridResp]:[any, any,any])=> {
        if(catEmpJobResp && bpResp && hybridResp ) {

          this.employeeJobCatalog=catEmpJobResp.data.filter(e=> e.id<4);
          this.hybridSchemaCatalog = hybridResp.data;
          if (this.mode === 'edit'){
            //////console.warn(this.hybridSchemaCatalog)
          this.getDataCreatedSchema();
          }


          this.businessProductCatalog=bpResp.data.filter(e=> e.idCatalogType!=3).map(function(row) {
            return { id : row.idCatalogType, description : row.description }
          });

         /* if(this.mode==="edit" || this.mode==="detail"){
            this.getSalePromotionCatalogs(commissionSaleId);
          }else{
            this.viewStatus=1;
          }*/
          this.viewStatus=1;


        }
        else throwError;
      }),
      catchError(error=> {
        //console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }


  getSalePromotionCatalogs=(commissionSaleId:number)=> {
    forkJoin(
      this.commissionSalePromotionsService.getListEmployeeJobs(commissionSaleId),
      this.commissionSalePromotionsService.getListBusinessProducts(commissionSaleId),
      this.commissionSalePromotionsService.getListFinancingTypes(commissionSaleId),
      this.commissionSalePromotionsService.getListPaymentTerms(commissionSaleId),
      this.commissionSalePromotionsService.getListAfiliates(commissionSaleId),
      this.commissionSalePromotionsService.getListFinancing(commissionSaleId),
      this.commissionSalePromotionsService.getListRegions(commissionSaleId),
      this.commissionSalePromotionsService.getListStates(commissionSaleId)
    )
    .pipe(
      tap(([employeeJobResp,businessProductResp,financingTypeResp,paymentTermResp,afiliateResp,financingResp,regionResp,stateResp]:[any, any, any, any, any, any, any, any])=> {
        if(employeeJobResp && businessProductResp && financingTypeResp && paymentTermResp && afiliateResp && financingResp && regionResp && stateResp) {

          //Cargar PUESTOS SELECCIONADOS
          this.selectedEmployeeJobs=employeeJobResp.data;
          this.selectedEmployeeJobsDD=employeeJobResp.data.map(function(row){
            return parseInt(row.id);
          });

          //Cargar LINEAS DE NEGOCIO SELECCIONADAS
          this.selectedBusinessProducts=businessProductResp.data;
          this.selectedBusinessProductsDD=businessProductResp.data.map(function(row){
            return parseInt(row.id);
          });

          //Cargar PRODUCTOS SELECCIONADOS
          this.selectedProducts = financingTypeResp.data.map(function(row){
            return { _id : row.id, _name : row.description }
          });

          //Cargar CONVENIOS SELECCIONADOS
          afiliateResp.data.forEach(function(row){
            this.selectedAfiliates.push({ _id : row.id, _name : row.description });
          },this);

          //Cargar CATALOGO DE PRODUCTOS
          let businessProductId:number[]=[];
          this.selectedBusinessProductsDD.forEach((el)=>{
            businessProductId.push(parseInt(el));
          });
          this.loadProducts(businessProductId);


          //Cargar CATALOGO DE CONVENIOS
          let financingTypeId:number[]=[];
          this.selectedProducts.forEach((el)=>{
            financingTypeId.push(el._id);
          });
          this.loadAfiliates(financingTypeId);

          //Cargar CATALOGO DE PLAZOS
          let afiliateId:number[]=[];
          this.selectedAfiliates.forEach((el)=>{
            afiliateId.push(el._id);
          });
          this.loadPaymentTerms(afiliateId, paymentTermResp);

          //Cargar PLAZOS SELECCIONADOS
          this.selectedPaymentTerms = paymentTermResp.data.map(function(row){
            return {
              _id : row.id,
              _name : row.description,
              _commission : null,
              _isEditable : false  }
          });

          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        //console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();

  }
  loadProducts=(businessProductId:number[])=> {
    this.loadingProducts = 1;
    if(businessProductId != null && businessProductId.length > 0){
      this.vwCommissionConfiguratorService.getFinancingTypesByBusinessProduct(businessProductId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.productCatalog = resp.data.map(function(row) {
            return { _id : row.id, _name : row.description }
          });
          this.loadingProducts = 0;
        }
      });
    }
  }
  loadAfiliates=(financingTypeId:number[])=>{
    this.loadingAfiliates = 1;
    console.log("FINANCINGTYPE -----> " + financingTypeId);
    if(financingTypeId != null && financingTypeId.length > 0){
      this.vwCommissionConfiguratorService.getAfiliatesByFinancingType(financingTypeId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          console.log("AFILIATE--------> " + resp.data)
          this.afiliateCatalog=resp.data.map(function(row) {
            return { _id : row.id, _name : row.description }
          });
          this.loadingAfiliates = 0;
        }
      });
    }
  }

  loadPaymentTerms=(afiliateId:number[], paymentTermResp:any)=>{
    this.loadingPaymentTerms = 1;
    if(afiliateId != null && afiliateId.length > 0){
      this.vwCommissionConfiguratorService.getPaymentTermsByAfiliate(afiliateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.paymentTermCatalog2=resp.data.map(function(row) {
            return {
              _id : row.id,
              _name : row.description}
          });
          console.log(">>> this.paymentTermCatalog=", this.paymentTermCatalog2);
          if(paymentTermResp != null && this.selectedPaymentTerms.length === 0){
            //Cargar PLAZOS SELECCIONADOS
            this.selectedPaymentTerms = paymentTermResp.data.map(function(row){
              return { _id : row.id, _name : row.description }
            });
          }
          this.loadingPaymentTerms = 0;
        }
      });
    }
  }

  setCategory(){

    if(this.applyCategory==true && this.termVal == true){

      this.paymentTermCatalog2=[
        { _id : 1, _name : "12 MESES", _checked: true, _ckbId : "ckbId_1"},
        { _id : 2, _name : "18 MESES", _checked: true, _ckbId : "ckbId_2"},
        { _id : 4, _name : "24 MESES", _checked: true, _ckbId : "ckbId_3"},
        { _id : 7, _name : "36 MESES", _checked: true, _ckbId : "ckbId_4"},
        { _id : 10, _name : "48 MESES", _checked: true, _ckbId : "ckbId_5"},
        { _id : 12, _name : "60 MESES", _checked: true, _ckbId : "ckbId_6"}
      ]
      this.categoryPromoterService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.categoryCatalog=resp.data.map(function(row){
            return {
              _id : row.promoterCategoryId,
              _name : row.description,
              _commission : null,
              _isEditable : true,
              _commissionApplied: false
            }
          });
          console.error(">>> this.categoryCatalog=", this.categoryCatalog);
          if(this.mode==='edit'){
            this.paymentTermCatalog2 = this.paymentTermCatalog3
            this.categoryCatalog = this.categoryCatalogEdit

              console.log(">>> this.paymentTermCatalog2=", this.paymentTermCatalog2);
            }

        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de categorías.'));
        })
      )
    .subscribe();
    }else if (this.applyCategory == true && this.termVal== false) {
      this.categoryPromoterService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.categoryCatalog=resp.data.map(function(row){
            return {
              _id : row.promoterCategoryId,
              _name : row.description,
              _commission : null,
              _isEditable : true,
              _commissionApplied: false
            }
          });
          this.paymentTermCatalog2=[
            { _id : 1, _name : "12 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
            { _id : 2, _name : "18 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
            { _id : 4, _name : "24 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
            { _id : 7, _name : "36 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
            { _id : 10, _name : "48 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
            { _id : 12, _name : "60 MESES", _commission: null, _isEditable: true, _commissionApplied: false}
          ]
          if(this.mode==='edit'){
            this.paymentTermCatalog2 = this.paymentTermCatalog
              console.log(">>> this.categoryCatalogEdit=", this.paymentTermCatalog2);
            }
          console.log(">>> this.categoryCatalog only", this.categoryCatalog);
          console.log(">>> this..paymentTermCatalog2 only", this.paymentTermCatalog2);
        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de categorías.'));
        })
      )
    .subscribe();
    }
    else if (this.applyCategory == false && this.termVal== true) {
      this.paymentTermCatalog2=[
        { _id : 1, _name : "12 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 2, _name : "18 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 4, _name : "24 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 7, _name : "36 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 10, _name : "48 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 12, _name : "60 MESES", _commission: null, _isEditable: true, _commissionApplied: false}
      ]
      this.categoryPromoterService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.categoryCatalog=resp.data.map(function(row){
            return {
              _id : row.promoterCategoryId,
              _name : row.description,
              _commission : null,
              _isEditable : true,
              _commissionApplied: false
            }
          });
          if(this.mode==='edit'){
            this.paymentTermCatalog2 = this.paymentTermCatalog
              console.log(">>> this.paymentTermCatalog=", this.paymentTermCatalog2);
            }
          console.warn(">>> this.categoryCatalog=", this.categoryCatalog);
          console.warn(">>> this.payment=", this.paymentTermCatalog);
        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de categorías.'));
        })
      )
    .subscribe();

    }else{
      this.paymentTermCatalog2=[
        { _id : 1, _name : "12 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 2, _name : "18 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 4, _name : "24 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 7, _name : "36 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 10, _name : "48 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
        { _id : 12, _name : "60 MESES", _commission: null, _isEditable: true, _commissionApplied: false}
      ]

      this.categoryPromoterService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.categoryCatalog=resp.data.map(function(row){
            return {
              _id : row.promoterCategoryId,
              _name : row.description,
              _commission : null,
              _isEditable : true,
              _commissionApplied: false
            }
          });

          if(this.mode==='edit'){
            this.paymentTermCatalog2 = this.paymentTermCatalog
              console.log(">>> this.paymentTermCatalog=", this.paymentTermCatalog2);
            }
        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de categorías.'));
        })
      )
    .subscribe();
    }

  }

  editPaymentCommission(item){
    item._isEditable=true;
  }

onCheck2(e) {

  if (e._isEditable) {
    console.warn("Entra 1")
    if(e._commission != null){
    this.selectedPaymentTerms.push(e._id);

      e._commissionApplied=true;
    }
    e._isEditable = false
  } else {
    console.warn("Entra 2")
    e._isEditable = true
    e._commissionApplied=false;
    var index = this.selectedPaymentTerms.indexOf(e._id);
    if (index > -1) {
      this.selectedPaymentTerms.splice(index, 1);
    }
  }
  console.log(this.selectedPaymentTerms);
}

onCheck3(e) {

  if (e._isEditable) {
    e._isEditable = false
    console.warn("Entra 1")
    if(e._commission != null){
    this.selectedCatPromotor.push(e._id)
    console.log("ID PROMOTOR  ---> " + this.selectedCatPromotor);
      e._commissionApplied=true;
    }

  } else {
    console.warn("Entra 2")
    e._isEditable = true
    e._commissionApplied=false;
    var index = this.selectedPaymentTerms.indexOf(e._id);
    if (index > -1) {
      this.selectedCatPromotor.splice(index, 1);

    }
  }
  console.log(this.selectedCatPromotor);
}


  confirmPaymentCommission(item){
    item._isEditable=false;
    console.error("entra 1")
    if(item._commission != null || this.mode=== 'edit'){
      console.error("entra 2")
      item._commissionApplied=true;
      if (this.termVal && !this.applyCategory ){
        console.error("entra 3")
        this.selectedPaymentTerms.push(item._id)
        console.log("ID PLAZO solo  ---> " + this.selectedPaymentTerms);
      }else if (this.applyCategory && !this.termVal){
        console.error("entra 4")
        this.selectedCatPromotor.push(item._id)
        console.log("ID PROMOTOR  ---> " + this.selectedCatPromotor);
        this.selectedPaymentTerms.push(item._commission)


        console.log("PROMOTOR RATE  ---> " + this.selectedPaymentTerms);
      }else if (this.termVal && this.applyCategory){
        console.error("entra 5")

        this.selectedCatPromotor.push(item._id)
        console.log("ID PROMOTOR  ---> " + this.selectedCatPromotor);
        this.selectedTermsPromoter.push(item._commission)
        console.log("PROMOTOR RATE  ---> " + this.selectedTermsPromoter);
        /*this.selectedPaymentTermsBoth.push(item._id)
        console.log("PLAZOS  ---> " + this.selectedPaymentTermsBoth);*/
      }

    } else {
      item._commissionApplied=false;


    }
  }

  confirmDirectCommission(directRate: number ){

    this.editDirectRate=false;
    if (directRate != null){
      this.directRate = directRate;
      console.log(this.directRate)
    }else{
      this.directRate = null;
      console.log(this.directRate)
    }

  }
  editDirectCommission(){
    this.editDirectRate=true;
  }


  onCheck(e) {
    if (!this.selectedPaymentTerms.includes(e._id)) {
      this.selectedPaymentTerms.push(e._id);
    } else {
      var index = this.selectedPaymentTerms.indexOf(e._id);
      if (index > -1) {
        this.selectedPaymentTerms.splice(index, 1);
      }
    }
    console.log(this.selectedPaymentTerms);
  }
  checkPaymentTerm(item){

      if (this.termVal && this.applyCategory){


        if((<HTMLInputElement>document.getElementById(item._ckbId)).checked){
          if(item._id != null){
            this.selectedPaymentTerms.push(item._id)
          }

          console.log("ID PLAZO  con promotor2 ---> " ,this.selectedPaymentTerms);
          item._checked = true;
        } else {
          item._checked = false;

        }


      }else{
        if((<HTMLInputElement>document.getElementById(item._ckbId)).checked){
          if(item._id != null){
            this.selectedPaymentTerms.push(item._id)
          }
          console.log("ID PLAZO  con promotor ---> " + this.selectedPaymentTerms);
          item._checked = true;
        } else {
          item._checked = false;

        }
      }


    console.log(">> CHECKED: "+item._id)
  }

  ReadSelectedValues(){
    this.saveRequestDTO.subSchemaHeader.name = this.salePromotion.description.toUpperCase();
    this.saveRequestDTO.catAfiliateHM = [];
    this.saveRequestDTO.catBusinessProduct = [];
    this.saveRequestDTO.catEmployeeJob = [];
    this.saveRequestDTO.catOwnerType = [];
    this.saveRequestDTO.catPaymentTerm = [];
    this.saveRequestDTO.catPromoterCategory = [];
    this.saveRequestDTO.productosCOE = [];
    this.saveRequestDTO.hybridSchemaId = null;
    this.saveRequestDTO.subSchemaHeaderId = null;

    this.selectedCatBusinessProduct = [];
    this.selectedCatEmployeeJob= [];
    this.selectedCommisionPercent = [];
    this.selectedBusinessCoE = [];
    this.selectedCatAffiliate = [];
    this.selectedCategories =[];
    this.selectedTermsPromoter=[];

    this.selectedCategory = [];

    //this.selectedPaymentTerms=[];

    //this.selectedTerm= [];

    //this.saveRequestDTO.subSchemaHeader.name = this.salePromotion.description.toUpperCase();
    this.saveRequestDTO.userId = Number(localStorage.getItem('com_token'))
    this.saveRequestDTO.subSchemaHeader.activeId = 1
    this.saveRequestDTO.hybridSchemaId= this.selectedhybridSchemaId;

    //PUSH ARRAY TO BACK (¬¬)
    //LINEA DE FONDEO CARTERA PROPIA DURO
    this.saveRequestDTO.catOwnerType[0] = 1;

    //linea de negocio
    this.selectedBusinessProducts.forEach((el)=>{
      this.selectedCatBusinessProduct.push(el.id);
    });
    this.saveRequestDTO.catBusinessProduct = this.selectedCatBusinessProduct
    //Trabajador
    if(this.mode === 'create'){
      this.selectedEmployeeJobs.forEach((el)=>{
        this.selectedCatEmployeeJob.push(el.id);
      });

    }else if (this.mode === 'edit'){
      if(this.selectedEmployeeJobs[0]== 1 || this.selectedEmployeeJobs[0]== 2 || this.selectedEmployeeJobs[0]== 3){
        this.selectedEmployeeJobs.forEach((el)=>{
          if(el.id !== undefined){
            this.selectedCatEmployeeJob.push(el.id);
          }

        });
      }else{
        this.selectedCatEmployeeJob=[];
        this.selectedEmployeeJobs.forEach((el)=>{
          if(el.id.id !== undefined){
            this.selectedCatEmployeeJob.push(el.id.id);
          }

        });
      }

    }
    this.saveRequestDTO.catEmployeeJob = this.selectedCatEmployeeJob

    //PRODUCTOS
    this.selectedProducts.forEach((el)=>{
      this.selectedBusinessCoE.push(el._id);

    });

    this.saveRequestDTO.productosCOE = this.selectedBusinessCoE

    //DEPENDENCIAS
    this.selectedAfiliates.forEach((el)=>{
      this.selectedCatAffiliate.push(el._id);

    });
    this.saveRequestDTO.catAfiliateHM = this.selectedCatAffiliate


    //PORCIENTO DE COMISIÓN Y PLAZO
    this.paymentTermCatalog2.forEach((el)=>{
      this.selectedCommisionPercent.push(el._commission);
    });
    this.saveRequestDTO.termRate = this.selectedCommisionPercent


    //PLAZO TERM ARREGLAR GUARDA UNA VEZ AFIRMADO
    //selectedTerm

    if (this.applyCategory && this.termVal){
      this.selectedPaymentTerms = this.uniqByForEach(this.selectedPaymentTerms);
      if(this.selectedPaymentTerms !== null){
        this.saveRequestDTO.catPaymentTerm = this.selectedPaymentTerms
      }

    }else if (!this.applyCategory && this.termVal){
      this.selectedPaymentTerms=this.uniqByForEach(this.selectedPaymentTerms);
      if(this.selectedPaymentTerms !== null){
        this.saveRequestDTO.catPaymentTerm = this.selectedPaymentTerms
      }
      console.log(this.saveRequestDTO.catPaymentTerm);
    } else if (this.applyCategory && !this.termVal){

      this.paymentTermCatalog2.forEach((el)=>{
        this.nonSelectedPaymentFull.push(el._id);
      });
      console.log(this.paymentTermCatalog2)
      console.log(this.nonSelectedPaymentFull);
      if(this.nonSelectedPaymentFull !== null){
        this.saveRequestDTO.catPaymentTerm = this.nonSelectedPaymentFull
      }

      console.log(this.saveRequestDTO.catPaymentTerm);
    }



    //SI ES COMISIÓN DIRECTA
    if (!this.affiliateVal){

      this.afiliateCatalog.forEach((el)=>{
        this.selectedCatAffiliate.push(el._id);

      });
      //////console.warn(this.afiliateCatalog)
      this.saveRequestDTO.catAfiliateHM = this.selectedCatAffiliate
    }
    if (!this.affiliateVal){

      this.productCatalog.forEach((el)=>{
        this.selectedBusinessCoE.push(el._id);

      });

    }
    if (!this.termVal){
      this.paymentTermCatalog2.forEach((el)=>{

        this.selectedPaymentTerms.push(el._id);

      });
      this.saveRequestDTO.catPaymentTerm = this.selectedPaymentTerms
    }

    if (!this.applyCategory){
      this.categoryCatalog.forEach((el)=>{
        this.selectedCategories.push(el._id);
      });
      this.saveRequestDTO.catPromoterCategory = this.selectedCategories;
    }


   if (!this.applyCategory ){
      console.log("DESACTIVADA LA CATEGORIA")

      if(this.directVal){
        //////console.warn(this.directRate)
        this.saveRequestDTO.termRate = [this.directRate,this.directRate,this.directRate,this.directRate,this.directRate,this.directRate];

      }

      //this.saveRequestDTO.catPromoterCategory = [0];//REVISAR
    }else{
      this.selectedCatPromotor.forEach((el)=>{
        this.selectedCategories.push(el);

      });
      this.saveRequestDTO.catPromoterCategory = this.selectedCategories;


        this.categoryCatalog.forEach((el)=>{
          if(el._isEditable){
            this.selectedCategory.push(el._isEditable)
          }


         if(el._commissionApplied){
          this.selectedTermsPromoter.push(el._commission);
         }else{
          this.selectedTermsPromoter.push(null);
         }



        });
        this.saveRequestDTO.termRate = this.selectedTermsPromoter



    }
    if(this.saveRequestDTO.catBusinessProduct[0] == 2){
      this.saveRequestDTO.catOwnerType[1] = 4;
    }

    if(this.mode === 'edit') {
      this.saveRequestDTO.subSchemaHeaderId = this.subSchemaHeaderIdEdit;
    }


    this.validateFields()
    console.log("Longitud -------->", this.saveRequestDTO.catAfiliateHM)
    console.warn(this.saveRequestDTO);// VERIFICADOR


  }

  saveRequestHybridComission(saveRequestDTO: SaveFinalCommissionSubSchema){
    this.repeatedAffiliates = [] ;
    this.viewStatus = 0;
    this.catHybridComissionService.saveSubSquema(saveRequestDTO)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            //request.SubSchemaHeader.salePromotionId = resp.data.salePromotionId;


            this.toastr.success('SE HAN GURADADO CON ÉXITO LAS COMISIONES');

          }else if (resp.data != null && resp.codeHttpStatus === 206){
            //this.modalService.dismissAll('success');

            //console.error(resp.data[0].final)
            if (resp.data[0].final == 0){
              Swal.fire('SE HAN GURADADO CON ÉXITO LAS COMISIONES' + this.repeatedAffiliates , '', 'success')
              this.modalService.dismissAll('success');
            }else{
              resp.data.forEach((el)=>{
                this.repeatedAffiliates.push('<BR> <label style="color: green;">  ' +el.Description + '</label> # ID ('+ el.SubSchemaHeader+') ' );
              });
              Swal.fire('ADVERTENCIA','La(s) dependendencia(s) ya han sido dadas de alta ' + this.repeatedAffiliates , 'warning')

              this.modalService.dismissAll('success');
              if(this.mode === 'edit'){
                //this.deleteTransitSchema(this.saveRequestDTO.subSchemaHeaderId);

              }
            }


          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta... MENSAJE 1'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar la promoción de venta... MENSAJE'));
        })
      )
      .subscribe();
  }




  SaveFinalSubSquema(){



    if (!this.affiliateVal){
      this.loadtodosConveniosXProducto();// SI NO SE SELECCIONA , TOMA TODOS LOS CONVENIOS DE LA LINEA DE NEGOCIO
    }else{
      this.ReadSelectedValues();
    }if(this.excecuteSave == 1){
      if(this.salePromotion.description != null ){

    ////////console.warn("VALIDACIÓN PREVIA " , this.saveRequestDTO);


    Swal.fire({
    title: '¿Guardar Esquema?',
    text: "Está seguro de guardar el esquema: " + this.saveRequestDTO.subSchemaHeader.name ,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#dd3030',
    confirmButtonText: 'GUARDAR',
    cancelButtonText: 'CANCELAR',
    allowOutsideClick: true
    }).then((result) => {

      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        Swal.showLoading();
        if(this.mode ==='edit')
        {
          this.editing = 1;
          this.deleteTransitSchema(this.saveRequestDTO.subSchemaHeaderId);
          this.getAndUpdateSelectedHSchema(this.saveRequestDTO.subSchemaHeaderId);
          this.saveRequestHybridComission(this.saveRequestDTO);

        }else if(this.mode === 'create'){
          this.editing = 1;
          this.saveRequestHybridComission(this.saveRequestDTO);
        }



      } else if (result.isDenied) {
        Swal.fire('CANCELADO', '', 'info')
      }
    })

    }else{
      console.log("El nombre viene Vacio")
    }
  }else{
    console.log("No se puede guardar, hay bandera de ejecucion")
  }
}


  uniqByForEach<T>(array: T[]) {
    const result: T[] = [];
    array.forEach((item) => {
        if (!result.includes(item)) {
            result.push(item);
        }
    })
    return result;
}




getSelectedHSchema=(getSelectedSchemas:string)=> {
  this.catHybridComissionService.getSelectedSchemas(getSelectedSchemas)
    .pipe(
      tap((resp:any)=> {
        this.flatSchemaList=resp.data;
        console.log("flat schema", this.flatSchemaList);
        this.ValidateFieldsForm(this.flatSchemaList);
        this.viewStatus=1;

      }),
      catchError(error=> {
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
      })
    )
    .subscribe();
}

ValidateFieldsForm(schemasArray:SelectedHSchema[] ){

  this.affiliateVal= false;
  this.termVal= false;
  this.promoterVal= false;
  this.directVal= false;
  this.applyCategory=false;

    schemasArray.forEach((sa)=>{

      if(schemasArray.length > 1){
        if (sa.CommissionSchemaId == 1){
          this.promoterVal = true ;
          this.applyCategory=true;
        }else if (sa.CommissionSchemaId == 5){
          this.directVal= true;
        }else if (sa.CommissionSchemaId == 6){
          this.affiliateVal= true;
        }else if (sa.CommissionSchemaId == 9){
          this.termVal= true;
        }else {
         this.toastr.warning("Por el momento no se puede utilizar esta configuración | " + sa.SchemaName+ " | ", "ATENCIÓN");
        }
      }else if(schemasArray.length == 1){
        if(sa.CommissionSchemaId == 1 || sa.CommissionSchemaId == 9){
          this.directVal= false;
        } else{
          this.directVal= true;
        }


        if (sa.CommissionSchemaId == 1){
          this.promoterVal = true ;
          this.applyCategory = true ;
        }else if (sa.CommissionSchemaId == 5){

        }else if (sa.CommissionSchemaId == 6){
          this.affiliateVal= true;
        }else if (sa.CommissionSchemaId == 9){
          this.termVal= true;
        }else {
         this.toastr.warning("Por el momento no se puede utilizar esta configuración| " + sa.SchemaName+ " | " , "ATENCIÓN");
        }
      }else{
        this.toastr.info("Seleccione un esquema.", "ATENCIÓN");
      }



  });

  this.setCategory();

  console.log(" |CONVENIO: " + this.affiliateVal +  " | PLAZO: "  +    this.termVal +    " | PROMOTOR: "  +   this.applyCategory+ " | PROMOTOR2: " + this.promoterVal+   " | DIRECTO: "  +      this.directVal)
}


getDataCreatedSchema(){
  //this.selectedProducts = [];

  let CatPaymentTerm=[
    { _id : 1, _name : "12 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 2, _name : "18 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 4, _name : "24 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 7, _name : "36 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 10, _name : "48 MESES", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 12, _name : "60 MESES", _commission: null, _isEditable: true, _commissionApplied: false}
  ]
  let CatPaymentTerm2=[
    { _id : 1, _name : "12 MESES", _checked: false, _ckbId : "ckbId_1"},
    { _id : 2, _name : "18 MESES", _checked: false, _ckbId : "ckbId_2"},
    { _id : 4, _name : "24 MESES", _checked: false, _ckbId : "ckbId_3"},
    { _id : 7, _name : "36 MESES", _checked: false, _ckbId : "ckbId_4"},
    { _id : 10, _name : "48 MESES", _checked: false, _ckbId : "ckbId_5"},
    { _id : 12, _name : "60 MESES", _checked: false, _ckbId : "ckbId_6"}
  ]
  let CatPromoterCategory=[
    { _id : 1, _name : "ULTRA", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 2, _name : "DIAMANTE", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 3, _name : "ORO", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 4, _name : "PLATA", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 5, _name : "BASE", _commission: null, _isEditable: true, _commissionApplied: false},
    { _id : 6, _name : "BRONCE", _commission: null, _isEditable: true, _commissionApplied: false}
  ]

  let catBusinessProducts: number [] = []
  let CatEmployeeJob: number [] = []
  let CatAfiliateHM: number [] = []
  let ProductosCOE: number [] =[]

  let directRateEdit: number = 0;
  //let CatPromoterCategory: any []= [];
  //let CatPaymentTerm: any [] = [];
  this.modActiveId = this.subSchemaHeader.ActiveId;
  let HybridSchema = this.listConfiguratedSchema.find(i => i.TableName === 'CatHybridCommissionSchema')
  this.subSchemaHeaderIdEdit = HybridSchema.SubSchemaId;




 this.listConfiguratedSchema.find((Value ,i )=> {

  if(Value.TableId == 2){
    if(Value.Value != undefined){
      catBusinessProducts.push(Value.Value);
    }

  }
  if(Value.TableId == 3){
    ProductosCOE.push(Value.Value);

    //this.selectedProducts = [{_id: ProductosCOE[0]},{_id: ProductosCOE[1]} ]
  }

  if(Value.TableId == 5){
    CatAfiliateHM.push(Value.Value);
  }
  if(Value.TableId == 6 && Value.TableName === 'CatPromoterCategory'){
    directRateEdit = Value.CommisionPercent
    if( Value.PromotorId == 1){
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "ULTRA",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.PromotorId == 2){
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "DIAMANTE",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.PromotorId == 3){
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "ORO",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.PromotorId == 4){
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "PLATA",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.PromotorId == 5){
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "BASE",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.PromotorId == 6){
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "BRONCE",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else{
      CatPromoterCategory.push({_id: Value.PromotorId, _name: "ERROR",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});

    }

    if( Value.Value == 1){
      CatPaymentTerm2.push({_id: Value.Value, _name: "12 MESES", _checked: true, _ckbId : "ckbId_1"});
    }else  if( Value.Value == 2){
      CatPaymentTerm2.push({_id: Value.Value, _name: "18 MESES",  _checked: true, _ckbId : "ckbId_2"});
    }else  if( Value.Value == 4){
      CatPaymentTerm2.push({_id: Value.Value, _name: "24 MESES", _checked: true, _ckbId : "ckbId_3"});
    }else  if( Value.Value == 7){
      CatPaymentTerm2.push({_id: Value.Value, _name: "36 MESES",  _checked: true, _ckbId : "ckbId_4"});
    }else  if( Value.Value == 10){
      CatPaymentTerm2.push({_id: Value.Value, _name: "48 MESES",  _checked: true, _ckbId : "ckbId_5"});
    }else  if( Value.Value == 12){
      CatPaymentTerm2.push({_id: Value.Value, _name: "60 MESES", _checked: true, _ckbId : "ckbId_6"});
    }else{
      CatPaymentTerm2.push({_id: Value.Value, _name: "ERROR", _checked: true, _ckbId : "ckbId_7"});

    }

  }else if (Value.TableId == 6 && Value.TableName === 'CatPaymentTerm'){

    if( Value.Value == 1){
      CatPaymentTerm.push({_id: Value.Value, _name: "12 MESES",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.Value == 2){
      CatPaymentTerm.push({_id: Value.Value, _name: "18 MESES",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.Value == 4){
      CatPaymentTerm.push({_id: Value.Value, _name: "24 MESES",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.Value == 7){
      CatPaymentTerm.push({_id: Value.Value, _name: "36 MESES",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.Value == 10){
      CatPaymentTerm.push({_id: Value.Value, _name: "48 MESES",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else  if( Value.Value == 12){
      CatPaymentTerm.push({_id: Value.Value, _name: "60 MESES",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});
    }else{
      CatPaymentTerm.push({_id: Value.Value, _name: "ERROR",  _commission :  Value.CommisionPercent, _isEditable : false, _commissionApplied: true});

    }

  }

  if(Value.TableId == 7){
    CatEmployeeJob.push(Value.Value);
  }



 });


  //VALORES UNICOS EN PRODUCTOS Y CONVENIOS
  CatAfiliateHM = this.uniqByForEach(CatAfiliateHM);
  ProductosCOE = this.uniqByForEach(ProductosCOE);


  const CatPromoterCategoryUnique = [...new Map(CatPromoterCategory.map(item =>
    [item['_id'], item])).values()];
    const CatPaymentTermUnique = [...new Map(CatPaymentTerm.map(item =>
      [item['_id'], item])).values()];
      const CatPaymentTerm2Unique = [...new Map(CatPaymentTerm2.map(item =>
        [item['_id'], item])).values()];

  //TERMINAN VALORES ÚNICOS.
  CatPromoterCategoryUnique.forEach(el => {
    this.categoryCatalogEdit.push(el)
    this.selectedCatPromotor.push(el._id);
    this.selectedTermsPromoter.push(el._commission);

  });

  CatPaymentTermUnique.forEach(el => {
    this.paymentTermCatalog.push(el)
    this.selectedTerm.push(el._id);
    if(el._commission != null){
      this.selectedPaymentTerms.push(el._id);
    }


  });
  console.error(CatPaymentTermUnique)
  CatPaymentTerm2Unique.forEach(el => {
    this.paymentTermCatalog3.push(el)
    this.selectedTerm.push(el._id);
    if(el._checked){
      this.selectedPaymentTerms.push(el._id);
    }
  });
  console.error(CatPaymentTermUnique)

  ProductosCOE.forEach(el => {

    this.selectedProducts.push({ _id : el});

  });
  CatAfiliateHM.forEach(el => {
    this.selectedAfiliates.push({ _id : el.toString()});
  });

  console.warn(this.selectedAfiliates);

  //////console.warn("Validador de obtención" ,this.selectedProducts)
  console.warn("Validador de obtención" ,this.paymentTermCatalog3)//DEBE SER STRING ¬¬

  this.salePromotion.description  = this.subSchemaHeader.ESQUEMA
  this.title = this.title + " ~  <b>" + this.subSchemaHeader.ESQUEMA + "</b>"
  this.getSelectedHSchema(HybridSchema.Value.toString());
   //console.log("linea ",catBusinessProducts)
   this.hybridChange(HybridSchema)
   this.businessProductChange(catBusinessProducts)
   this.employeeJobChange(CatEmployeeJob);
   this.productsChange(this.selectedProducts)
   this.afiliatesChange(this.selectedAfiliates)
   this.confirmDirectCommission(directRateEdit);


}


getAndUpdateSelectedHSchema=(subSchemaHeader:number)=> {

  this.commissionSalePromotionsService.getStatusSchema(subSchemaHeader)

    .pipe(
      tap((resp:any)=> {


        this.activeOrinactive=resp.data[0].activeId;

        if(this.activeOrinactive == 0 ){
          //this.activeOrinactive = 1
          //this.statusResponse = "SE HA ACTIVADO "
        }else if (this.activeOrinactive == 1){
          this.activeOrinactive =0
          this.statusResponse = "SE HA DESACTIVADO "
        }
        this.updateSelectedHSchema(subSchemaHeader,this.activeOrinactive);




      }),
      catchError(error=> {
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
      })
    )
    .subscribe();
}

updateSelectedHSchema=(subSchemaHeader:number, activeId:number)=> {
  this.viewStatus = 0;
  this.commissionSalePromotionsService.updateStatusSchema(subSchemaHeader, activeId)
    .pipe(
      tap((resp:any)=> {
      console.log(resp);


      //Swal.fire("CORRECTO ",this.statusResponse + "EL SUBSCHEMA " + subSchemaHeader ,  'success')

      //this.modalService.dismissAll('success');


      }),
      catchError(error=> {
        this.viewStatus=1;
        return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
      })
    )
    .subscribe();
}

deleteTransitSchema=(subSchemaHeader:number)=> {
  this.viewStatus = 0;
  this.commissionSalePromotionsService.deleteTransitSchema(subSchemaHeader)
    .pipe(
      tap((resp:any)=> {
      console.log(resp);
      //Swal.fire("CORRECTO ",this.statusResponse + "EL SUBSCHEMA " + subSchemaHeader + " SE HA ELIMINADO",  'error')
      }),
      catchError(error=> {
        this.viewStatus=1;
        return of(this.toastr.error('Ocurrió un error al sustituir la base del esquema'));
      })
    )
    .subscribe();
}

viewIfExist=(subSchemaHeader:number)=> {
  this.viewStatus = 0;
  this.commissionSalePromotionsService.viewIfExist(subSchemaHeader)
    .pipe(
      tap((resp:any)=> {
      this.ifExistOnTransit = resp.data;
      console.log("EXISTE EN TRANSIT ", this.ifExistOnTransit)
      }),
      catchError(error=> {
        this.viewStatus=1;
        return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
      })
    )
    .subscribe();
}

getTransitSchemaOld=(subSchemaHeader:number)=> {
  //this.viewStatus = 0;

  this.commissionSalePromotionsService.getTansitSchemaOld(subSchemaHeader)
    .pipe(
      tap((resp:any)=> {

        this.transitSchemaOld= resp.data;
      console.log(this.transitSchemaOld )


      //this.restoreTransitSchema(this.transitSchemaOld);
      }),
      catchError(error=> {
        this.viewStatus=1;
        return of(this.toastr.error('Ocurrió un error al obtener el Esquema base '));
      })
    )
    .subscribe();
}

restoreTransitSchema=(transitSchemaOld:TransitSchema[])=> {
  //this.viewStatus = 0;

 console.warn (transitSchemaOld)
  this.commissionSalePromotionsService.restoreTransitSchema(transitSchemaOld)
    .pipe(
      tap((resp:any)=> {

      this.transitSchemaOld = resp.data;


      }),
      catchError(error=> {
        this.viewStatus=1;
        return of(this.toastr.warning('Ocurrió un error al obtener el guardar el schema '));
      })
    )
    .subscribe();
}

validateFields(){

    this.excecuteSave = 1;

  if(this.saveRequestDTO.catEmployeeJob.length <= 0){
    this.toastr.info("NO HA SELECCIONADO PUESTO")
    this.excecuteSave = 0;
  }
  if(this.saveRequestDTO.catPaymentTerm.length <= 0){
    this.toastr.info("NO HA SELECCIONADO NUNGÚN PLAZO")
    this.excecuteSave = 0;
  }
  if(this.saveRequestDTO.catPromoterCategory.length <= 0){
    this.toastr.info("NO HA SELECCIONADO CATEGORIA DE PROMOTOR")

    this.excecuteSave = 0;
  }
  if(this.saveRequestDTO.productosCOE.length <= 0){
    this.toastr.info("NO HA SELECCIONADO NINGÚN PRODUCTO ")
    this.excecuteSave = 0;
  }
  if(this.saveRequestDTO.catBusinessProduct.length <= 0){
    this.toastr.info("NO HA SELECCIONADO LINEA DE NEGOCIO")
    this.excecuteSave = 0;

  }if(this.saveRequestDTO.catAfiliateHM.length <= 0){
    this.toastr.info("NO HA SELECCIONADO NINGÚN CONVENIO")
    this.excecuteSave = 0;
  }
  if(this.saveRequestDTO.subSchemaHeader.name.length <= 0){
    this.toastr.info("NO HA COLOCADO NINGÚN NOMBRE")
    this.excecuteSave = 0;
  }
  if(this.directVal){

    if(typeof this.saveRequestDTO.termRate[0] === 'undefined' || this.saveRequestDTO.termRate[0] == null ){
      this.toastr.info("ASIGNE UN PORCENTAJE DIRECTO")
      this.excecuteSave = 0;
    }


  }
  if(this.selectedCategory.length >0){
    this.toastr.warning("DEBERÁ SELECCIÓNAR TODAS LAS CATEGORIAS")
    this.excecuteSave = 0;
  }



}

}
